<template>
  <div class="row">
    <div class="col-md-12">
    </div>
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-3">
          <div class="pull-left">
            <label>
              <input type="search" class="form-control input-sm" placeholder="Suche..." v-model="searchQuery" aria-controls="datatables">
            </label>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="pull-right">
            <vue-excel-xlsx
              class="btn btn-default btn-fill btn-wd"
              :data="rankingsData"
              :columns="rankingColumns"
              filename="Tippspiel_Gesamtwertung"
              sheetname="Gesamtwertung"
            >
              Gesamtwertung
            </vue-excel-xlsx>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="pull-right">
            <vue-excel-xlsx
              class="btn btn-default btn-fill btn-wd"
              :data="userData"
              :columns="columns"
              filename="Tippspiel_Benutzer"
              sheetname="Benutzer"
            >
              Download
            </vue-excel-xlsx>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="pull-right">
            <button class="btn btn-default btn-fill btn-wd" @click="addUser">Benutzer hinzufügen</button>
          </div>
        </div>
        <div class="col-sm-12">
          <el-table class="table-striped"
                    :data="queriedData"
                    @row-click="rowClicked"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :align='column.align'
                             :class-name='column.class'
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <!--
            <el-table-column
              :min-width="60"
              fixed="right"
              label="Actions">
              <template slot-scope="props">
                <a class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="handleEdit(props.$index, props.row)"><i class="ti-pencil-alt"></i></a>
                <a class="btn btn-simple btn-xs btn-danger btn-icon remove"  @click="handleDelete(props.$index, props.row)"><i class="ti-close"></i></a>
              </template>
            </el-table-column>
            -->
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">{{from + 1}} bis {{to}} von {{total}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import users from './users'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
    computed: {
      columns () {
        if (this.$store.state.betgameData && this.$store.state.betgameData.id === 3004) {
          return [
            {
              label: 'ID',
              field: 'id'
            },
            {
              label: 'Name',
              field: 'nickname'
            },
            {
              label: 'Email',
              field: 'email'
            },
            {
              label: 'Location',
              field: 'source'
            },
            {
              label: 'Status',
              field: 'status'
            }
          ]
        } else {
          return [
            {
              label: 'ID',
              field: 'id'
            },
            {
              label: 'Name',
              field: 'nickname'
            },
            {
              label: 'Email',
              field: 'email'
            },
            {
              label: 'Adresse',
              field: 'address'
            },
            {
              label: 'PLZ',
              field: 'zip'
            },
            {
              label: 'Ort',
              field: 'city'
            },
            {
              label: 'Werbeeinwilligung',
              field: 'allow_email'
            },
            {
              label: 'Status',
              field: 'status'
            }
          ]
        }
      },
      userData () {
        return this.$store.state.users
      },
      rankingColumns () {
        return [
          {
            label: 'Position',
            field: 'position'
          },
          {
            label: 'Name',
            field: 'user_name'
          },
          {
            label: 'Email',
            field: 'user_email'
          },
          {
            label: 'Punkte',
            field: 'points_total'
          },
          {
            label: 'Spieltagssiege',
            field: 'matchday_wins'
          },
          {
            label: 'Exakte Tipps',
            field: 'exact'
          },
          {
            label: 'Tordifferenz',
            field: 'goaldiff'
          },
          {
            label: 'Tendenz',
            field: 'tendency'
          },
          {
            label: 'Abgegebene Tipps',
            field: 'betcount'
          },
          {
            label: 'Sonderfragen',
            field: 'question_points'
          },
          {
            label: 'Punktekorrekturen',
            field: 'points_correction'
          }
        ]
      },
      rankingsData () {
        return this.$store.state.totalRankings
      },
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              if (row[key] === undefined || row[key] === null) {
                continue
              }
              let rowValue = row[key].toString().toLowerCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.$store.state.users.length
        return this.$store.state.users.length
        // this.pagination.total = this.tableData.length
        // return this.tableData.length
      },
      tableData () {
        return this.$store.state.users
      }
    },
    data () {
      return {
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['id', 'nickname', 'email', 'source', 'status'],
        tableColumns: [
          {
            prop: 'id',
            label: 'ID',
            minWidth: 60,
            align: 'right',
            class: 'id-column'
          },
          {
            prop: 'nickname',
            label: 'Name',
            minWidth: 130
          },
          {
            prop: 'email',
            label: 'Email',
            minWidth: 170
          },
          {
            prop: 'source',
            label: 'Source',
            minWidth: 80
          },
          {
            prop: 'status',
            label: 'Status',
            minWidth: 80
          }
        ]
        // tableData: users
      }
    },
    created () {
      this.$log.debug('UsersPaginatedTables.created')
    },
    beforeCreate () {
      this.$log.debug('UsersPaginatedTables.beforeCreate')
    },
    mounted () {
      this.$log.debug('UsersPaginatedTables.mounted')
      const b = this.$store.state.betgame
      if (b > -1 && this.$store.getters.loggedIn) {
        this.$store.dispatch('fetchUsers', {betgame: b, offset: -1, limit: -1}).then(() => {
          this.pagination.total = this.$store.state.usercount
        })
        this.$store.dispatch('fetchTotalRankings', b).then(() => {

        })
      }
      this.$store.dispatch('fetcheUserBetgamePoints', b)
    },
    methods: {
      rowClicked (rowdata) {
        this.$log.debug('rowClicked ' + JSON.stringify(rowdata))
        this.$router.push('user/' + rowdata.id)
      },
      addUser () {
        // alert('Benutzer hinzufügen')
        this.$router.push('user/0')
      },
      handleEdit (index, row) {
        // alert(`Edit ${row.nickname}`)
        this.$router.push('user/' + row.id)
      },
      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          var r = confirm('Benutzer ' + row.nickname + ' (' + row.email + ') löschen?')
          if (r === true) {
            this.$store.dispatch('updateUser', {
              id: row.id,
              content: {
                status: 'inactive'
              }
            }).then(() => {
              this.tableData.splice(indexToDelete, 1)
            })
          }
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tables/UsersPaginatedTables.vue